/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
  useLocation,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Spin } from 'antd';
import 'antd/dist/antd.less';
import './configs/color.less';
import routes from './configs/route';
import { AuthService } from './services';
import AppWrapper from './App.style';
import URL from './configs/baseUrl';
import 'antd/dist/antd.css';
import { loginRedirect } from './utils/commonUtils';

const PrivateRoute = ({ component: Component, exact, path, ...rest }) => {
  const { pathname } = useLocation();

  return (
    <Route
      {...rest}
      render={() => {
        if (AuthService.isUserAuthenticated()) {
          return <Component />;
        }
        return <Redirect to={loginRedirect({ targetPath: pathname })} />;
      }}
      exact={exact}
    />
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <AppWrapper>
        <Router>
          <React.Suspense fallback={<Spin />}>
            <Switch>
              {routes.map((route) => {
                if (route.isPublic) {
                  return (
                    <Route
                      path={route.path}
                      component={route.component}
                      key={route.path}
                      exact={route.path === URL.HOME}
                    />
                  );
                }
                return (
                  <PrivateRoute
                    path={route.path}
                    component={route.component}
                    key={route.path}
                    exact={route.path === URL.HOME}
                  />
                );
              })}
            </Switch>
          </React.Suspense>
        </Router>
      </AppWrapper>
    </HelmetProvider>
  );
};

export default App;
